var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import styles from "./index.module.css";
import { Register } from "@/04-features/register-popup";
import { Login } from "@/04-features/login-popup";
import { validateSession } from "@/05-models/auth";
import { logout as logoutReq } from "@/05-models/auth";
import { useErrorNotify } from "@/06-shared/lib/errorNotifier";
export const Topbar = ({ children }) => {
    const [showLoginPopup, isLoginPopupShown] = useState(false);
    const [showRegisterPopup, isRegisterPopupShown] = useState(false);
    const [isAuthed, setIsAuthed] = useState(false);
    const showError = useErrorNotify();
    const check = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            yield validateSession();
            setIsAuthed(true);
        }
        catch (e) {
            setIsAuthed(false);
        }
    });
    useEffect(() => {
        check();
    }, []);
    const logout = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            yield logoutReq();
            setIsAuthed(false);
        }
        catch (error) {
            showError(error);
        }
    });
    return (_jsxs("div", { className: styles.topbarWrapper, children: [_jsx("p", { className: styles.logoText, children: "TBD" }), _jsx("div", { children: children }), _jsx("div", { className: styles.navSection, children: isAuthed ? (_jsx("p", { className: styles.navOption, onClick: () => logout(), children: "[logout]" })) : (_jsxs(_Fragment, { children: [_jsx("p", { className: styles.navOption, onClick: () => isLoginPopupShown(true), children: "[login]" }), _jsx("p", { className: styles.navOption, onClick: () => isRegisterPopupShown(true), children: "[register]" })] })) }), _jsx(Register, { isOpen: showRegisterPopup, onClose: () => { isRegisterPopupShown(false); }, onSuccess: () => { isRegisterPopupShown(false); setIsAuthed(true); } }), _jsx(Login, { isOpen: showLoginPopup, onClose: () => { isLoginPopupShown(false); }, onSuccess: () => { isLoginPopupShown(false); setIsAuthed(true); } })] }));
};
